export const LONG_DESCRIPTON_FORM_CODE = '15d';
